import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getDataAttributes } from '../../../../../../util/getDataAttributes/getDataAttributes.js';
import '../../../../../../util/styles/index.js';
import { ClearButton } from '../../../FormField/components/ClearButton/ClearButton.js';
import { DEFAULT_PROPS_VALUES, CLEAR_BUTTON_DEFAULT_STYLES, TEXTAREA_DEFAULT_STYLES } from '../../constants.js';
import { useIsClearButtonVisible } from '../useIsClearButtonVisible/useIsClearButtonVisible.js';
import { useSmartResize } from '../useSmartResize/useSmartResize.js';
import { useTextareaContainerStyles } from '../useTextareaContainerStyles/useTextareaContainerStyles.js';
import { READ_ONLY_DEFAULT_STYLES, DISABLED_DEFAULT_STYLES } from '../../../../shared/constants.js';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["containerRef", "disabled", "readOnly", "value", "children", "resize", "minHeight", "maxHeight", "rows"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useTextarea = function useTextarea(props, ref) {
  var containerRef = props.containerRef,
    disabled = props.disabled,
    readOnly = props.readOnly,
    value = props.value,
    children = props.children,
    _props$resize = props.resize,
    resize = _props$resize === void 0 ? DEFAULT_PROPS_VALUES.resize : _props$resize,
    _props$minHeight = props.minHeight,
    minHeight = _props$minHeight === void 0 ? DEFAULT_PROPS_VALUES.minHeight : _props$minHeight,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? DEFAULT_PROPS_VALUES.maxHeight : _props$maxHeight,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? DEFAULT_PROPS_VALUES.rows : _props$rows,
    rest = _objectWithoutProperties(props, _excluded);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var containerProps = useTextareaContainerStyles({
    resize: resize,
    disabled: disabled,
    minHeight: minHeight,
    maxHeight: maxHeight,
    readOnly: readOnly
  });
  var _getDataAttributes = getDataAttributes(rest),
    dataAttributes = _getDataAttributes.dataAttributes,
    textareaRest = _getDataAttributes.rest;
  var _useSmartResize = useSmartResize(containerRef, ref, resize, value),
    inputRef = _useSmartResize.inputRef,
    textareaContainerRef = _useSmartResize.containerRef;
  var isClearBtnVisible = useIsClearButtonVisible(children);
  var clearBtnStyles = React.useMemo(function () {
    return /*#__PURE__*/React.isValidElement(children) && children.type === ClearButton ? mapAdsStyles(CLEAR_BUTTON_DEFAULT_STYLES) : null;
  }, [children, mapAdsStyles]);

  // Base textarea styles
  var textareaStyles = mapAdsStyles(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, TEXTAREA_DEFAULT_STYLES), readOnly && _objectSpread({}, READ_ONLY_DEFAULT_STYLES)), disabled && _objectSpread({}, DISABLED_DEFAULT_STYLES)), {}, {
    pe: isClearBtnVisible && '32',
    // Add padding if ClearButton is visible
    textVariant: 'body-default'
  }));
  textareaStyles.style = _objectSpread(_objectSpread({}, textareaStyles.style), {}, {
    resize: 'none',
    fontFamily: 'inherit'
  }); // Always set resize to none to control via container

  return {
    textareaProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, textareaStyles), textareaRest), dataAttributes), {}, {
      rows: rows,
      disabled: disabled,
      readOnly: readOnly,
      value: value,
      ref: inputRef
    }),
    clearBtnStyles: clearBtnStyles,
    containerProps: _objectSpread(_objectSpread({}, containerProps), {}, {
      ref: textareaContainerRef
    })
  };
};

export { useTextarea };
//# sourceMappingURL=useTextarea.js.map
